
export enum DataPoolGlobalKeys  {     
  ['global.config'] ='global.config',
  ['global.config.cmdCompletion'] ='global.config.cmdCompletion',
  ['global.config.nmea'] ='global.config.nmea',
  ['global.config.msgAccueil'] ='global.config.msgAccueil',
  ['global.config.homeImages'] ='global.config.homeImages',
  ['global.config.passwordPolicy'] ='global.config.passwordPolicy'
}

export enum DataPoolMissionKeys  {
  ['fileTransfer.config'] ='fileTransfer.config',
  logbook ='logbook'
}

export enum DataPoolEnseigneKeys  {
  graphics ='graphics'
}

export const buildDataMissionKey = (mid:number,key:DataPoolMissionKeys) => `mission.${mid}.${key}`
export const buildDataEnseigneKey = (ensId:number,key:DataPoolEnseigneKeys) => `enseigne.${ensId}.${key}`